import { Colors, DropdownListItem, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import DateTimePicker from "react-datetime-picker";
import styled from "styled-components";
import { RectangularButtonFilled } from "shared/components/buttons";

export const Wrapper = styled(FlexBox)`
  .ui-input_container {
      background-color: #fefefe !important;

      ${DropdownListItem} {
        background-color: #fefefe !important;
      }
    }
`

export const FirstBlock = styled.div`
  display: grid;
  width: 100%;
  min-width: 0;
  gap: 16px 24px;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-areas:
    'header calendar'
    'button calendar';
  align-items: start;

  .dropdown-list-item {
    min-height: 40px !important;
    height: min-content !important;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'header'
      'calendar'
      'button';
    gap: 24px;
  }
`;

export const FirstBlockHeader = styled.div`
  grid-area: header;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const CalendarWrapper = styled.div`
  grid-area: calendar;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  gap: 24px;
  min-width: 0;
`;

export const DateFieldsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  gap: 16px;
  min-width: 0;

  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-direction: column;
  }
`;

export const ConsultationLimitRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  gap: 16px;
  min-width: 0;

  .common-checkbox {
    width: auto !important;
    max-width: 100%;
  }

  .info-icon-wrapper {
    flex-shrink: 0;
    margin-left: 0;
    right: auto;
  }

  .type-theme-input {
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const DateFieldColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
`;

export const StyledDateTimePicker = styled(DateTimePicker)<{ isMobile?: boolean }>`
  display: flex !important;
  width: 100% !important;
  max-width: 100% !important;

  .react-datetime-picker__wrapper {
    border: none;
    border-radius: 3px;
    padding: 0 16px;
    background-color: ${Colors.geoWhite100};
    height: ${({ isMobile }) => (isMobile ? '40px' : '48px')};
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0;
    flex: 1 1 auto;
    flex-shrink: 1;
    box-sizing: border-box;
    
    svg {
      path {
        fill: ${Colors.galBlack61};
      }
    }
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 40px;
    }
  }

  .react-datetime-picker__inputGroup {
    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider {
      outline: none;
      color: #151514 !important;
      font-size: ${({ isMobile }) => (isMobile ? '13px' : '15px')} !important;
      line-height: ${({ isMobile }) => (isMobile ? '16px' : '20px')} !important;
    }
  }

  .react-calendar {
    background: ${Colors.geoWhite100};
    border: 1px solid ${Colors.galBlack10};
    border-radius: 3px;
    
    .react-calendar__tile--now {
      background-color: ${Colors.galBlack10} !important;
      color: ${Colors.galBlack100} !important;
    }
    
    .react-calendar__tile--active {
      background-color: ${Colors.galBlack100} !important;
      color: ${Colors.geoWhite100} !important;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    .react-datetime-picker__wrapper {
      background-color: ${Colors.galBlack5};
    }
  }
`;


export const SectionTitle = styled(FlexBox)`
  font-family: Inter;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.44px;
  color: #151514;
`;


export const SectionSubtitle = styled(FlexBox)`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #909090;
  letter-spacing: -0.3px;
`;

export const SecondBlock = styled(FlexBox)`
  flex-direction: row;
  width: 100%;
  gap: 16px;
  align-items: flex-start;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    gap: 12px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-direction: column;
    gap: 16px;
  }

`

export const CalendarLabel = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #909090;
  letter-spacing: -0.3px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.26px;
  }
`;

export const DayButton = styled.button<{ isSelected: boolean }>`
  font-size: 17px;
  line-height: 22px;
  font-weight: ${({ isSelected }) => (isSelected ? '600' : '400')};
  color: ${({ isSelected }) => (isSelected ? '#151514' : '#909090')};
  background-color: ${({ isSelected }) => (isSelected ? '#CDCDCD' : '#E7E7E7')};
  border: none;
  outline: none;
  border-radius: 3px;
  padding: 10px 13px;
  cursor: pointer;
  transition: all 0.2s;
  width: 48px;
  height: 48px;
  

  &:hover {
    background-color: #CDCDCD;
  }
  &:focus {
    outline: none;
    border: none;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 40px;
    height: 40px;
    padding: 9px 6px;
    }
`;


export const DaysContainer = styled(FlexBox)`
  flex-wrap: wrap;
  height: 48px;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
`;





export const ClockIcon = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${Colors.galBlack10};
  }

  svg {
    width: 16px;
    height: 16px;
    
    path {
      fill: ${Colors.galBlack61};
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    right: 8px;
    width: 28px;
    height: 28px;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export const LessonTypeWrapper = styled(FlexBox)`
  width: 165px;
  height: 48px;

  .ui-input_container {
    height: 48px !important;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 140px;
    height: 40px;

    .ui-input_container {
      height: 40px !important;
    }
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
`;




export const ZoomLink = styled.a`
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: #151514;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 8px;
  word-break: break-all;
  max-width: 185px;

  &:hover {
    color: ${Colors.galBlack73};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 12px;
    line-height: 14px;
    max-width: 150px;
  }
`;


export const GroupButton = styled.button<{ isSelected: boolean; $inline?: boolean }>`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #151514;
  border: 1px solid #909090;
  border-radius: 5px;
  padding: 5px 16px;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
  white-space: nowrap;

  &:hover {
    background-color: #E7E7E7;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    padding: 5px 16px;
  }
`;


export const GroupsContainer = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
  max-width: 620px;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 410px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    max-width: 100%;
  }
`;


export const GroupsRow = styled.div`
   display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px 16px;
   @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    display: flex;
    flex-wrap: wrap;

  }
`;


export const GroupsSection = styled(FlexBox)`
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
`;


export const DatePickerContainer = styled.div`
  display: block;
  width: 100%;
  max-width: 235px;
  min-width: 0;

  .react-datetime-picker,
  .date-input {
    display: flex !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .react-datetime-picker__wrapper {
    width: 100% !important;
    max-width: 100% !important;
    flex-shrink: 1;
  }

  .react-datetime-picker__inputGroup {
    width: auto !important;
    max-width: none !important;
    flex: 1 1 auto;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 100%;
  }
`;


export const ScheduleTableWrapper = styled(FlexBox)`
  width: 100%;
  flex-direction: column;
`;

export const ScheduleHeader = styled(FlexBox)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const SmartAutofillLink = styled.a`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #151514;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${Colors.galBlack73};
  }
`;

export const ScheduleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    display: none;
  }
`;

export const TableHeader = styled.thead`
  th {
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #909090;
    text-align: left;
    padding: 12px 0;
    border-bottom: 1px solid ${Colors.galBlack10};
  }
`;

export const TableBody = styled.tbody`
    color: #909090;
    font-family: Inter;
    font-weight: 400;
`;

export const ScheduleRow = styled.tr<{ hasMissingGroup?: boolean }>`
  td {
    padding-top: 12px;
    padding-bottom: 12px;
    background-color: ${({ hasMissingGroup }) => (hasMissingGroup ? '#CDCDCD' : 'transparent')};
  }
  
  &:not(:last-child) {
    border-bottom: 1px dashed #909090;
  }
`;

export const TableCell = styled.td`
  vertical-align: middle;
  padding-right: 24px;
  
  &:last-child {
    padding-right: 0;
  }
`;

export const DateCell = styled(TableCell)`
  max-width: 100px;
`;

export const TimeCell = styled(TableCell)`
  max-width: 130px;
`;

export const GroupCell = styled(TableCell)`
  max-width: 140px;
`;

export const ThemeCell = styled(TableCell)`
  max-width: 300px;
  min-width: 140px;
`;

export const LocationCell = styled(TableCell)`
  width: 130px;
  max-width: 130px;
`;

export const ActionsCell = styled(TableCell)`
  width: 60px;
  padding: 0;
  text-align: center;
`;

export const DateText = styled.div`
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;

  span {
    color: #909090;
    margin-left: 4px;
  }
`;

export const TimeText = styled.div`
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: center;
`;

export const LocationText = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #909090;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  word-break: break-word;
  max-width: 100px;
  cursor: pointer;
  
  a {
    display: inline-block;
    line-height: 1.2;
  }
  &:hover {
    color: #545453;
  }
`;

export const ThemeText = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #909090;
  cursor: pointer;
  border-radius: 3px;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #545453;
  }
`;

export const GroupText = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #909090;
  cursor: pointer;
  border-radius: 3px;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #545453;
  }
`;

export const MobileCardsContainer = styled(FlexBox)`
  display: none;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    display: flex;
  }
`;

export const MobileCard = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
  padding: 16px;
  background-color: transparent;
  border-radius: 3px;
  border: 1px solid ${Colors.galBlack10};
  gap: 12px;
`;

export const MobileCardHeader = styled(FlexBox)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const MobileCardDateTime = styled(FlexBox)`
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const MobileCardDate = styled.div`
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;
  
  span {
    color: #909090;
    margin-left: 4px;
  }
`;

export const MobileCardTime = styled.div`
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    
    path {
      fill: #909090;
    }
  }
`;

export const MobileCardDeleteButton = styled.button`
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: ${Colors.galBlack47};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;

  &:hover {
    color: ${Colors.galBlack100};
  }
`;

export const MobileCardGroups = styled.div`
  font-size: 15px;
  line-height: 20px;
  color: #151514;
  cursor: pointer;
  
  &:hover {
    opacity: 0.7;
  }
`;

export const MobileCardTheme = styled(FlexBox)`
  width: 100%;
`;

export const MobileCardLocation = styled.div`
  font-size: 15px;
  line-height: 20px;
  color: #151514;
  word-break: break-all;
`;

export const GroupSelectWrapper = styled(FlexBox)`
  position: relative;
  width: 100%;
  font-size: 13px;
  line-height: 16px;
  align-items: center;
  
  input[type="checkbox"] {
    accent-color: transparent;
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #909090;
    border-radius: 2px;
    background-color: transparent;
    position: relative;
    cursor: pointer;
    margin: 0;
    
    &:checked {
      background-color: transparent;
      border-color: #909090;
      
      &::after {
        content: '✓';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #151514;
        font-size: 12px;
        line-height: 1;
      }
    }
    
    &:hover {
      border-color: #151514;
    }
  }
  
  input[type="radio"] {
    accent-color: transparent;
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    min-width: 16px;
    height: 16px;
    border: 1px solid #909090;
    border-radius: 50%;
    background-color: transparent;
    position: relative;
    cursor: pointer;
    margin: 0;
    
    &:checked {
      background-color: transparent;
      border-color: #909090;
      
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #151514;
      }
    }
    
    &:hover {
      border-color: #151514;
    }
  }
`;

export const AddSlotButton = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid ${Colors.galBlack47};
  background-color: ${Colors.geoWhite100};
  color: ${Colors.galBlack47};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
  transition: all 0.2s;
  position: relative;
  z-index: 1;

  &:hover {
    background-color: ${Colors.galBlack5};
    border-color: ${Colors.galBlack100};
    color: ${Colors.galBlack100};
  }
`;

export const DeleteSlotButton = styled.button.attrs({ type: 'button' as const })`
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: ${Colors.galBlack47};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
  transition: all 0.2s;

  &:hover {
    color: ${Colors.galBlack100};
  }
`;

export const ActionsInner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const MoreActionsButton = styled.button.attrs({ type: 'button' as const })`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
  background: transparent;
  color: #909090;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;

  &:focus,
  &:focus-visible {
    outline: none;
  }

  &:hover {
    color: #151514;
  }
`;

export const ActionsMenu = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  z-index: 20;
  min-width: 220px;
  padding: 4px;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
`;

export const ActionsMenuItem = styled.button.attrs({ type: 'button' as const })`
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #151514;
  cursor: pointer;
  text-align: left;
  font-family: Inter;
  font-size: 15px;
  line-height: 20px;
  outline: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: #f2f2f2;
  }

  &:focus,
  &:focus-visible,
  &:active {
    outline: none;
    box-shadow: none;
    border: none;
  }
`;

export const DeleteTooltipWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  
  > div {
    justify-content: flex-start !important;
  }
`;



export const ModalTimeAndTypeRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 12px;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.s}px) {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
`;

export const OpenModalButton = styled(RectangularButtonFilled).attrs({ type: 'button' as const })<{ isBlocked?: boolean }>`
  grid-area: button;
  height: 48px;
  width: 390px;
  max-width: 100%;
  align-self: end;
  padding: 10px 24px;

  opacity: ${({ isBlocked }) => (isBlocked ? 0.5 : 1)};
  cursor: ${({ isBlocked }) => (isBlocked ? 'not-allowed' : 'pointer')};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
`;

export const StyledRectangularButtonFilled = styled(RectangularButtonFilled).attrs({ type: 'button' as const })`
  width: 360px;
  height: 48px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
`;import { Colors, DropdownListItem, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import DateTimePicker from "react-datetime-picker";
import styled from "styled-components";
import { RectangularButtonFilled } from "shared/components/buttons";

export const Wrapper = styled(FlexBox)`
  .ui-input_container {
      background-color: #fefefe !important;

      ${DropdownListItem} {
        background-color: #fefefe !important;
      }
    }
`

export const FirstBlock = styled.div`
  display: grid;
  width: 100%;
  min-width: 0;
  gap: 16px 24px;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-areas:
    'header calendar'
    'button calendar';
  align-items: start;

  .dropdown-list-item {
    min-height: 40px !important;
    height: min-content !important;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'header'
      'calendar'
      'button';
    gap: 24px;
  }
`;

export const FirstBlockHeader = styled.div`
  grid-area: header;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const CalendarWrapper = styled.div`
  grid-area: calendar;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  gap: 24px;
  min-width: 0;
`;

export const DateFieldsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  gap: 16px;
  min-width: 0;

  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-direction: column;
  }
`;

export const ConsultationLimitRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  gap: 16px;
  min-width: 0;

  .common-checkbox {
    width: auto !important;
    max-width: 100%;
  }

  .info-icon-wrapper {
    flex-shrink: 0;
    margin-left: 0;
    right: auto;
  }

  .type-theme-input {
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const DateFieldColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
`;

export const StyledDateTimePicker = styled(DateTimePicker)<{ isMobile?: boolean }>`
  display: flex !important;
  width: 100% !important;
  max-width: 100% !important;

  .react-datetime-picker__wrapper {
    border: none;
    border-radius: 3px;
    padding: 0 16px;
    background-color: ${Colors.geoWhite100};
    height: ${({ isMobile }) => (isMobile ? '40px' : '48px')};
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0;
    flex: 1 1 auto;
    flex-shrink: 1;
    box-sizing: border-box;
    
    svg {
      path {
        fill: ${Colors.galBlack61};
      }
    }
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 40px;
    }
  }

  .react-datetime-picker__inputGroup {
    .react-datetime-picker__inputGroup__day,
    .react-datetime-picker__inputGroup__month,
    .react-datetime-picker__inputGroup__leadingZero,
    .react-datetime-picker__inputGroup__year,
    .react-datetime-picker__inputGroup__divider {
      outline: none;
      color: #151514 !important;
      font-size: ${({ isMobile }) => (isMobile ? '13px' : '15px')} !important;
      line-height: ${({ isMobile }) => (isMobile ? '16px' : '20px')} !important;
    }
  }

  .react-calendar {
    background: ${Colors.geoWhite100};
    border: 1px solid ${Colors.galBlack10};
    border-radius: 3px;
    
    .react-calendar__tile--now {
      background-color: ${Colors.galBlack10} !important;
      color: ${Colors.galBlack100} !important;
    }
    
    .react-calendar__tile--active {
      background-color: ${Colors.galBlack100} !important;
      color: ${Colors.geoWhite100} !important;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    .react-datetime-picker__wrapper {
      background-color: ${Colors.galBlack5};
    }
  }
`;


export const SectionTitle = styled(FlexBox)`
  font-family: Inter;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.44px;
  color: #151514;
`;


export const SectionSubtitle = styled(FlexBox)`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #909090;
  letter-spacing: -0.3px;
`;

export const SecondBlock = styled(FlexBox)`
  flex-direction: row;
  width: 100%;
  gap: 16px;
  align-items: flex-start;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    gap: 12px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-direction: column;
    gap: 16px;
  }

`

export const CalendarLabel = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #909090;
  letter-spacing: -0.3px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.26px;
  }
`;

export const DayButton = styled.button<{ isSelected: boolean }>`
  font-size: 17px;
  line-height: 22px;
  font-weight: ${({ isSelected }) => (isSelected ? '600' : '400')};
  color: ${({ isSelected }) => (isSelected ? '#151514' : '#909090')};
  background-color: ${({ isSelected }) => (isSelected ? '#CDCDCD' : '#E7E7E7')};
  border: none;
  outline: none;
  border-radius: 3px;
  padding: 10px 13px;
  cursor: pointer;
  transition: all 0.2s;
  width: 48px;
  height: 48px;
  

  &:hover {
    background-color: #CDCDCD;
  }
  &:focus {
    outline: none;
    border: none;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 40px;
    height: 40px;
    padding: 9px 6px;
    }
`;


export const DaysContainer = styled(FlexBox)`
  flex-wrap: wrap;
  height: 48px;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
`;





export const ClockIcon = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${Colors.galBlack10};
  }

  svg {
    width: 16px;
    height: 16px;
    
    path {
      fill: ${Colors.galBlack61};
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    right: 8px;
    width: 28px;
    height: 28px;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export const LessonTypeWrapper = styled(FlexBox)`
  width: 165px;
  height: 48px;

  .ui-input_container {
    height: 48px !important;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 140px;
    height: 40px;

    .ui-input_container {
      height: 40px !important;
    }
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
`;




export const ZoomLink = styled.a`
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: #151514;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 8px;
  word-break: break-all;
  max-width: 185px;

  &:hover {
    color: ${Colors.galBlack73};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 12px;
    line-height: 14px;
    max-width: 150px;
  }
`;


export const GroupButton = styled.button<{ isSelected: boolean; $inline?: boolean }>`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #151514;
  border: 1px solid #909090;
  border-radius: 5px;
  padding: 5px 16px;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
  white-space: nowrap;

  &:hover {
    background-color: #E7E7E7;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    padding: 5px 16px;
  }
`;


export const GroupsContainer = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
  max-width: 620px;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 410px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    max-width: 100%;
  }
`;


export const GroupsRow = styled.div`
   display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px 16px;
   @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    display: flex;
    flex-wrap: wrap;

  }
`;


export const GroupsSection = styled(FlexBox)`
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
`;


export const DatePickerContainer = styled.div`
  display: block;
  width: 100%;
  max-width: 235px;
  min-width: 0;

  .react-datetime-picker,
  .date-input {
    display: flex !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .react-datetime-picker__wrapper {
    width: 100% !important;
    max-width: 100% !important;
    flex-shrink: 1;
  }

  .react-datetime-picker__inputGroup {
    width: auto !important;
    max-width: none !important;
    flex: 1 1 auto;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 100%;
  }
`;


export const ScheduleTableWrapper = styled(FlexBox)`
  width: 100%;
  flex-direction: column;
`;

export const ScheduleHeader = styled(FlexBox)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const SmartAutofillLink = styled.a`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #151514;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${Colors.galBlack73};
  }
`;

export const ScheduleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    display: none;
  }
`;

export const TableHeader = styled.thead`
  th {
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #909090;
    text-align: left;
    padding: 12px 0;
    border-bottom: 1px solid ${Colors.galBlack10};
  }
`;

export const TableBody = styled.tbody`
    color: #909090;
    font-family: Inter;
    font-weight: 400;
`;

export const ScheduleRow = styled.tr<{ hasMissingGroup?: boolean }>`
  td {
    padding-top: 12px;
    padding-bottom: 12px;
    background-color: ${({ hasMissingGroup }) => (hasMissingGroup ? '#CDCDCD' : 'transparent')};
  }
  
  &:not(:last-child) {
    border-bottom: 1px dashed #909090;
  }
`;

export const TableCell = styled.td`
  vertical-align: middle;
  padding-right: 24px;
  
  &:last-child {
    padding-right: 0;
  }
`;

export const DateCell = styled(TableCell)`
  max-width: 100px;
`;

export const TimeCell = styled(TableCell)`
  max-width: 130px;
`;

export const GroupCell = styled(TableCell)`
  max-width: 140px;
`;

export const ThemeCell = styled(TableCell)`
  max-width: 300px;
  min-width: 140px;
`;

export const LocationCell = styled(TableCell)`
  width: 130px;
  max-width: 130px;
`;

export const ActionsCell = styled(TableCell)`
  width: 60px;
  padding: 0;
  text-align: center;
`;

export const DateText = styled.div`
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;

  span {
    color: #909090;
    margin-left: 4px;
  }
`;

export const TimeText = styled.div`
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: center;
`;

export const LocationText = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #909090;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  word-break: break-word;
  max-width: 100px;
  cursor: pointer;
  
  a {
    display: inline-block;
    line-height: 1.2;
  }
  &:hover {
    color: #545453;
  }
`;

export const ThemeText = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #909090;
  cursor: pointer;
  border-radius: 3px;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #545453;
  }
`;

export const GroupText = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #909090;
  cursor: pointer;
  border-radius: 3px;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #545453;
  }
`;

export const MobileCardsContainer = styled(FlexBox)`
  display: none;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    display: flex;
  }
`;

export const MobileCard = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
  padding: 16px;
  background-color: transparent;
  border-radius: 3px;
  border: 1px solid ${Colors.galBlack10};
  gap: 12px;
`;

export const MobileCardHeader = styled(FlexBox)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const MobileCardDateTime = styled(FlexBox)`
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const MobileCardDate = styled.div`
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;
  
  span {
    color: #909090;
    margin-left: 4px;
  }
`;

export const MobileCardTime = styled.div`
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    
    path {
      fill: #909090;
    }
  }
`;

export const MobileCardDeleteButton = styled.button`
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: ${Colors.galBlack47};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;

  &:hover {
    color: ${Colors.galBlack100};
  }
`;

export const MobileCardGroups = styled.div`
  font-size: 15px;
  line-height: 20px;
  color: #151514;
  cursor: pointer;
  
  &:hover {
    opacity: 0.7;
  }
`;

export const MobileCardTheme = styled(FlexBox)`
  width: 100%;
`;

export const MobileCardLocation = styled.div`
  font-size: 15px;
  line-height: 20px;
  color: #151514;
  word-break: break-all;
`;

export const GroupSelectWrapper = styled(FlexBox)`
  position: relative;
  width: 100%;
  font-size: 13px;
  line-height: 16px;
  align-items: center;
  
  input[type="checkbox"] {
    accent-color: transparent;
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #909090;
    border-radius: 2px;
    background-color: transparent;
    position: relative;
    cursor: pointer;
    margin: 0;
    
    &:checked {
      background-color: transparent;
      border-color: #909090;
      
      &::after {
        content: '✓';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #151514;
        font-size: 12px;
        line-height: 1;
      }
    }
    
    &:hover {
      border-color: #151514;
    }
  }
  
  input[type="radio"] {
    accent-color: transparent;
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    min-width: 16px;
    height: 16px;
    border: 1px solid #909090;
    border-radius: 50%;
    background-color: transparent;
    position: relative;
    cursor: pointer;
    margin: 0;
    
    &:checked {
      background-color: transparent;
      border-color: #909090;
      
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #151514;
      }
    }
    
    &:hover {
      border-color: #151514;
    }
  }
`;

export const AddSlotButton = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid ${Colors.galBlack47};
  background-color: ${Colors.geoWhite100};
  color: ${Colors.galBlack47};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
  transition: all 0.2s;
  position: relative;
  z-index: 1;

  &:hover {
    background-color: ${Colors.galBlack5};
    border-color: ${Colors.galBlack100};
    color: ${Colors.galBlack100};
  }
`;

export const DeleteSlotButton = styled.button.attrs({ type: 'button' as const })`
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: ${Colors.galBlack47};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
  transition: all 0.2s;

  &:hover {
    color: ${Colors.galBlack100};
  }
`;

export const ActionsInner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const MoreActionsButton = styled.button.attrs({ type: 'button' as const })`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
  background: transparent;
  color: #909090;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;

  &:focus,
  &:focus-visible {
    outline: none;
  }

  &:hover {
    color: #151514;
  }
`;

export const ActionsMenu = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  z-index: 20;
  min-width: 220px;
  padding: 4px;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
`;

export const ActionsMenuItem = styled.button.attrs({ type: 'button' as const })`
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #151514;
  cursor: pointer;
  text-align: left;
  font-family: Inter;
  font-size: 15px;
  line-height: 20px;
  outline: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: #f2f2f2;
  }

  &:focus,
  &:focus-visible,
  &:active {
    outline: none;
    box-shadow: none;
    border: none;
  }
`;

export const DeleteTooltipWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  
  > div {
    justify-content: flex-start !important;
  }
`;



export const ModalTimeAndTypeRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 12px;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.s}px) {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
`;

export const OpenModalButton = styled(RectangularButtonFilled).attrs({ type: 'button' as const })<{ isBlocked?: boolean }>`
  grid-area: button;
  height: 48px;
  width: 390px;
  max-width: 100%;
  align-self: end;
  padding: 10px 24px;

  opacity: ${({ isBlocked }) => (isBlocked ? 0.5 : 1)};
  cursor: ${({ isBlocked }) => (isBlocked ? 'not-allowed' : 'pointer')};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
`;

export const StyledRectangularButtonFilled = styled(RectangularButtonFilled).attrs({ type: 'button' as const })`
  width: 360px;
  height: 48px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
`;